"use client";

import React, { Fragment } from "react";
import components from "../index";
export * from "./default/context";
import { ISalifyComponentContext, SalifyComponentContext } from "./default/context";
import { Typography } from "@mui/material";

export interface VariantProps {
  components: any[];
}

const SalifyComponent = (props: VariantProps) => {
  return (
    <>
      {props.components?.map((config, index) => {
        if (Array.isArray(config)) return <SalifyComponent key={index} components={config} />;

        if (config.$type === "layout-children" && !config.blockName) {
          return null;
        }

        const Component =
          (components as any)?.[config.blockName]?.[config.variant || "default"] ?? null;

        const ctxValue: ISalifyComponentContext = { ...config };

        return (
          <SalifyComponentContext.Provider key={index} value={ctxValue}>
            {Component ? (
              <Fragment key={index}>
                <Component {...config.props} />
              </Fragment>
            ) : (
              <Typography color="red">
                Chưa hỗ trợ component với block name: {JSON.stringify(config)}
              </Typography>
            )}
          </SalifyComponentContext.Provider>
        );
      })}
    </>
  );
};

SalifyComponent.Context = SalifyComponentContext;

export default SalifyComponent;
